<template>
    <div>
<!--Версія 3.5-->
        <div class="container-fluid">
            <div class="row">
                <nav class="col-md-2 d-none d-md-block bg-light sidebar">
                    <div class="sidebar-sticky">
                        <ul class="nav flex-column">
                            <li style="font-size: 1em" v-for="(r, i) in sortedRegions" :key="r.num" :class="{ active: i === activeItem}" @click="regionToShow(r.region_deputats,r.region_okrugs,r.region_num); selectItem(i)" >
                                {{r.region_name}}
                            </li>
                            <!--<li  :class="{ active: 0 === activeItem}" @click="regionToShow(84,9,99); selectItem(0)" >-->
                                <!--Львівська область-->
                            <!--</li>-->
                        </ul>

                    </div>
                </nav>
                <div role="main" class="col-md-10 ml-sm-auto col-lg-10 px-4 mainContainer" >
                    <div class="d-flex justify-content-center flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <!--<h2 >Попередні результати чергових виборів депутатів Львівської обласної ради 25 жовтня 2020 року-->
                            <!--<img src="https://www.lvivoblrada.gov.ua/img/logo-254x119.png" style="max-height: 80px" alt="">-->
                        <!--</h2>-->
                        <!--<br>-->

                        <h1 class="h2">Результати місцевих виборів Львівської області 2020</h1>
                        <!--<div class="btn-toolbar mb-2 mb-md-0">-->
                            <!--<div class="btn-group mr-2">-->
                                <!--<button  class="btn btn-outline-info mr-1" @click="showModule=6" >Результати по кожній ДВК</button>-->
                                <!--<button  class="btn btn-outline-secondary mr-1" @click="showModule=3" >Явка виборців</button>-->
                                <!--<button  class="btn btn-outline-secondary mr-1" @click="showModule=8" >Результати до ЛОР по ОТГ</button>-->
                                <!--<button  class="btn btn-outline-secondary mr-1" @click="showModule=4" >Присутність на ДВК</button>-->
                                <!--<button  class="btn btn-outline-secondary mr-1" @click="showModule=5" >Управління користувачами</button>-->
                                <!--<button  class="btn btn-outline-secondary mr-1" @click="showModule=7" >Результати на Голову ОТГ</button>-->

                            <!--</div>-->
                        <!--</div>-->
                    </div>

                    <!-- <h2>Section title</h2> -->
                    <!--<javka v-if="showModule==3" class="flex-fill"/>-->
                    <div v-show="showModule==1" class="flex-fill">

                        <div class="labelInfoContainer">
                            <ul class="lablesInfo  justify-content-around">
                                <li class="col-md-3"><span class="label"> {{ totalVotes.toLocaleString('ru-RU') }}</span><br>Всього проголосували</li>
                                <li class="col-md-3"><span class="label">{{ votesToCount.toLocaleString('ru-RU') }}</span><br>Голоси,за партії, що
                                    подолали 5%
                                </li>
                                <li class="col-md-3"><span class="label text-success">{{ elected }}</span><br>Партій проходять</li>
                                <li class="col-md-3"><span class="label"> {{ mandat.toLocaleString('ru-RU') }} </span><br>Виборча квота</li>
                            </ul>
                        </div>

                        <div class="progressBarContainer">
                            Внесені дані по: <strong>{{infoPercent.filled}} / {{infoPercent.total}} ДВК,  {{infoPercent.percent}}%</strong>
                            <div class="progress mb-1 border flex-grow-1" style="height: 10px">
                                <div class="progress-bar "
                                    :style="{'width': infoPercent.percent+'%','background-color': '#35adea','color':'black'}">
                                </div>
                            </div>
                        </div>
                        <p>Увага! При натисканні на назву партії у переліку,результати по кожному з кандидатів з'являться під таблицею. Для перегляду результатів по кожній ДВК натисніть <a href="https://docs.google.com/spreadsheets/d/1fc2w2ztpJRE3qbllL3xpMSyJMrlN5kLRs_PZhWGPo2I/edit?usp=sharing" class="btn btn-sm btn-info" target="_blank">ТУТ</a></p>
                        <div class="dataTab border-bottom">
                            <div class="lds-ring" v-if="isFetching"><div></div><div></div><div></div><div></div>
                            </div>

                            <table v-else class="table-bordered hoverTable">
                                <thead>
                                    <tr class="tabHeader">
                                        <th rowspan="2" class="tabCenter">№</th>
                                        <th rowspan="2" class="tabCenter">Назва партії</th>
                                        <th colspan="2" class="tabCenter">Голоси</th>
                                        <th rowspan="2" class="tabCenter">Кількість мандатів</th>
                                        <th :colspan="region_config.okrugsAmount" class="tabCenter">Округ</th>
                                    </tr>
                                    <tr class="tabHeader">
                                        <th>Кількість</th>
                                        <th>Відсоток</th>
                                        <th v-for="r in region_config.okrugsAmount" :key="r">№{{r}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <party-result 
                                        v-for="(res,index) in results" 
                                        :res="res" 
                                        :index="index" 
                                        :key="res.name"
                                        :maxMandats="maxMandats"
                                        :minMandats="minMandats"
                                        @showCand="showCandidates(res)" 
                                    />
                                </tbody>
                            </table>
                        </div>

                        <div class="d-flex flex-row candidates-container">
                            <candidates  v-if="showCandidatesModule" :party="party" :region_config="region_config" :mandat="mandat"/>
                        </div>

                    </div>
                    <!--<div class="flex-row justify-content-around mr-1">-->
                        <!--<is-online v-if="showModule ==4"/>-->
                        <!--<user-managment  v-if="showModule==5" :userType="{type:'dataEntry',region: 'ОТГ',listToGet:'otg_list'}" ></user-managment>-->
                        <!--<results-dvk v-if="showModule==6" :otgList="regions"></results-dvk>-->
                        <!--<main-admin-head v-if="showModule==7" :otgList="regions"></main-admin-head>-->
                        <!--<main-admin-info-otg v-if="showModule==8"></main-admin-info-otg>-->
                    <!--</div>-->

                </div>
            </div>
        </div>

</div>

</template>

<script>
    //import MainAdminInfoByOtg from './MainAdminInfoByOtg';
    //import userManagment from './userManagment.vue'
    //import isOnline from './isOnline';
    import partyResultEach from './partyResultEach.vue';
    // import regionTotals from './regionTotals.vue';
    // import resRow from './resRow';
    import Candidates from './Candidates.vue';
    //import javka from './javka.vue';
    //import resultsByDVK from './resultsByDVK';
    //import MainAdminHead from './MainAdminHead';

    export default {
        data() {
            return {
               // infoFor: '',
                regions: [{
                    region_name: 'Городоцький',
                    region_num: 6,
                    region_deputats: 34
                }],
                sortedRegions: [
                    //{num: 99, region_deputats: 64, region_num:99, region_okrugs:   },
                ],
                infoPercent: {
                    filled: 0,
                    total: 0,
                    percent: 0
                },
                region_config: {
                    okrugsAmount:9,
                    mandatsToDivide:84,
                    otg_num: 49
                },

                region:'',
                showCandidatesModule: false,
                isFetching: true,
                party: '',
                showModule: 1,
                totalVotes: 0,
                votesToCount: 0,
                elected: 0,
                mandat: 0,
                results: [
                ],
                maxMandats: null,
                minMandats: null,
                activeItem: null,
            }
        },

        created() {
            //this.getData();
            this.getRegions();
        },
        beforeMount() {
            //this.regionToShow(64,6,67); this.selectItem(0);
            this.regionToShow(84,9,99); this.selectItem(0);

        },
        mounted() {

        },
        name: 'MainAdmin',
        methods: {
            getRegions() {
                let token = sessionStorage.getItem('token');
                let sendData= {
                    'token': token,
                    'request': 'regions',
                };
                this.$http.post(this.$URL, sendData).then(response => {
                    if (response.data == 'ERROR') {
                         alert('Помилка оновлення даних: час вашої сесії вичерпано. \nБудь ласка, натисніть кнопку "Вийти" та знову зайдіть у свій обліковий запис');
                    }
                    this.regions = response.data;

                    const regionsToSort = this.regions.filter(o => o.region_num < 90);
                    regionsToSort.sort((a, b) => {
                        if (a.region_name > b.region_name) {
                            return 1;
                        }
                        if (b.region_name > a.region_name) {
                            return -1;
                        }
                        return 0;
                    });
                    //пересування літери І, бо вона сортується некоректно
                    regionsToSort.splice(26, 0, regionsToSort[0]);
                    regionsToSort.shift();

                    this.sortedRegions = [
                        this.regions.find(o => o.region_num == '99'),
                        ...this.regions.filter(o => o.region_num >= 90 && o.region_num != 99),
                        ...regionsToSort,
                    ];
                });

            },
            regionToShow(x, y, z) {
                document.activeElement.classList.add('active');

                y = parseInt(y);
                this.region_config.okrugsAmount = y;
                this.region_config.mandatsToDivide = x;
                this.region_config.otg_num = z;
                this.isFetching = true;
                this.elected = 0;
                this.mandat = 0;
                this.totalVotes = 0;
                this.votesToCount = 0;
                this.maxMandats = null;
                this.minMandats = null;
                //this.infoFor = z;
                this.getInfoPercent(z);
                this.results = [];
                this.showCandidatesModule = false;

                this.getData(z);
            },
            showCandidates(party) {
                if(party.isElected) {
                    this.showCandidatesModule = false;
                    this.party = party;
                    setTimeout(() => this.showCandidatesModule = true, 0.3);
                } else {
                    console.log('ніхто не пройшов');
                }
            },
            getTotalsForParties() {
                this.results.forEach(item => {
                    let a = this.getTotal(item.regionResults);
                    this.$set(item, 'totalVotesForParty', a);
                });
            },
            getInfoPercent(z){
                let sendData = {
                    'token':localStorage.getItem('token'),
                    'request': 'getInfoPercent',
                    'region': z
                };
                this.$http.post(this.$URL,sendData).then(response => {
                    if (response.data == 'ERROR') {
                         alert('Помилка оновлення даних: час вашої сесії вичерпано. \nБудь ласка, натисніть кнопку "Вийти" та знову зайдіть у свій обліковий запис');
                    }
                   // console.log(response.data);
                    let infoPercent = response.data[1]? +response.data[0].filled / +response.data[1].total*100 : 0;
                    infoPercent = infoPercent.toFixed(1);
                    this.infoPercent.filled = response.data[0].filled;
                    this.infoPercent.total = response.data[1].total;
                    this.infoPercent.percent = infoPercent ;
                    //console.log(this.infoPercent);
                });
            },
            getAllVotes() {
                return this.results.forEach(item => this.totalVotes += item.totalVotesForParty);
            },
            partyIsElected() {
                this.results.forEach(item => {
                    let x = item.totalVotesForParty / this.totalVotes * 100;
                    x = x.toFixed(2);
                    x = parseFloat(x);
                    this.$set(item, 'percent', x);
                    if (x > 5) {
                        this.$set(item, 'isElected', true);

                    } else {
                        this.$set(item, 'isElected', false);
                    }
                    this.elected = this.results.filter(item => item.isElected).length;
                    this.results.sort((a, b) => b.percent - a.percent);
                    //let a = 84 - this.elected;
                    //this.mandat = this.votesToCount / a;
                    //this.votesToCount = this.votesToCount.toFixed(0);
                })
            },
            getVotesToCount() {
                let a = this.results.filter(item => item.isElected);

                a.forEach(item => this.votesToCount += item.totalVotesForParty);
                let x = this.region_config.mandatsToDivide - this.elected;
                let y = this.votesToCount / x;
                y = y.toFixed(0);
                this.mandat = y;
            },
            getMandats() {
                let results = this.results.filter(item => item.isElected);
                results.forEach(item => {
                    let c = 0;
                    let d = 0;
                    for (let i = 0; i < this.region_config.okrugsAmount; i++) {
                        //
                        let a = item.regionResults[i] / this.mandat;
                        a = Math.trunc(a);
                        //Додаємо до купи усі мандати по округах
                        c += a;
                        let b = item.regionResults[i] % this.mandat;
                        //Додаємо усі залишки до купи
                        d += b;
                        //Записуємо усе в об'єкти
                        item.mandats[i] = a;
                        item.left[i] = b;
                        //Рахуємо мандати з центрального списку
                        let f = d / this.mandat;
                        f = Math.trunc(f);
                        //Записуємо усі мандати
                        item.totalMandats = f + c + 1;
                        //Залишок від залишку
                        item.totalLeft = d % this.mandat;
                        this.$set(item,'okrugMandats',c);
                    }
                    
                    this.maxMandats = this.results
                        .map(o => o.totalMandats)
                        .reduce((acc, cur) => cur > acc ? cur : acc, 0);

                    this.minMandats = this.results
                        .reduce((acc, cur) => {
                            return cur.isElected && acc > cur.totalMandats 
                                ? cur.totalMandats 
                                : acc
                        }, 9000000);
                        
                   // console.log(this.minMandats)
                })
            },
            getTotal(arr) {
                let a = arr.reduce((acc, item) => acc + item);
                a = parseInt(a);
                return a;
            },
            getData(region) {
                let token = sessionStorage.getItem('token');
                let sendData= {
                    'token': token,
                    'request': 'results',
                    'region': region
                };

                this.$http.post(this.$URL, sendData).then(response => { 
                    if (response.data == 'ERROR') {
                         alert('Помилка оновлення даних: час вашої сесії вичерпано. \nБудь ласка, натисніть кнопку "Вийти" та знову зайдіть у свій обліковий запис');
                    }
                    this.results = response.data;
                }).then(()=> this.pullDataTimed()).catch(err => console.log(err));
            },
            countFuckingLeftOvers() {
                let results = [...this.results.filter(item => item.isElected)];
                let c = 0;
                //Рахуємо скільки є мандатів всього
                results.forEach(item => c += item.totalMandats);
                //Невикористані мандати
                let f = this.region_config.mandatsToDivide - c;

                results.sort((a, b) => {
                    return b.totalLeft - a.totalLeft;
                });
                results = results.splice(0, f);
                for (let i = 0; i < this.results.length; i++) {
                    for (let j = 0; j < results.length; j++) {
                        if (this.results[i].name == results[j].name) {
                            this.results[i].totalMandats += 1;
                        }
                    }
                }

            },
            pullDataTimed() {
                this.getTotalsForParties();
                this.getAllVotes();
                this.partyIsElected();
                this.getVotesToCount();
                this.getMandats();
                this.countFuckingLeftOvers();
                this.isFetching = false;
                this.showModule = 1;
            },
            getGreenToRed(percent){
                let r = percent<50 ? 255 : Math.floor(255-(percent*2-100)*255/100);
                let g = percent>50 ? 255 : Math.floor((percent*2)*255/100);
                return 'rgb('+r+','+g+',0)';
            },
            selectItem(i) {
                this.activeItem = i;
            }
        },

        computed: {

            barColor() {
                return this.getGreenToRed(this.infoPercent);
            }

        },
        components: {
            //'user-managment':userManagment,

            'party-result': partyResultEach,
            'candidates': Candidates,
            // resRow,
          //  javka,
           //// isOnline,
           // 'results-dvk': resultsByDVK,
           // 'main-admin-head': MainAdminHead,
          // 'main-admin-info-otg': MainAdminInfoByOtg
            // 'regTot': regionTotals,
        }


    }
</script>


<style>
    html, body{
        font-family: 'Open Sans', sans-serif !important;
    }
    .mainContainer{
        padding: 70px 20px;
    }
    .btnCont{
        margin: 30px 0;
    }
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }

    .component-fade-enter, .component-fade-leave-to{
        opacity: 0;
    }

    .hoverTable {
        width: 100%;
        border-collapse: collapse;
    }
    .hoverTable{
        font-size: 12px;
        font-weight: 300;
    }
    .hoverTable td, .hoverTable th{
        padding: 5px;
    }
    .hoverTable tbody tr:nth-child(even) {
        background: #f1f1f1;
    }
    .hoverTable tbody tr:nth-child(odd) .candidates-cell {
        background: #ebfaff;
    }.hoverTable tbody tr:nth-child(even) .candidates-cell {
        background: #cff4ff;
    }
    .hoverTable tbody tr:hover {
        background-color: #ffff99;
        cursor: pointer;
    }
    .hoverTable td:first-child {
        text-align: left !important;
    }
    .lds-ring {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid #0028ff;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #83cdff transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    .table-bordered td {
        border: 1px solid #ffffff;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    .m30{
        margin: 30px 0;
    }
    .tabCenter{
        text-align: center;
    }
    .tabHeader{
        background: #969696;
        color: #fff;
    }
    .lablesInfo{
        margin: 30px 0;
    }
    .lablesInfo li{
        list-style: none;
        display: inline-block;
        /*width: 24%;*/
        text-align: center;
        font-size: 14px;
        font-weight: 300;
    }
    .label{
        font-size: 30px;
        font-weight: 400;
    }
    .progressBarContainer{
        margin: 20px 0 30px 0;
        font-size: 14px;
        font-weight: 300;
    }
    .progressBarContainer strong{
        font-size: 16px;
    }
    .text-success{
        font-weight: 500;
    }
    label{
        font-size: 16px;
    }
    .alert{
        font-size: 1rem;
    }
    .h1title{
        margin: 40px 0;
        font-size: 30px;
    }
    .form-inline{
        align-items: normal;
    }
    .progress-bar{
        background-color: #35adea !important;
    }
    .progress{
        border-radius: 2px;
    }
    .btn{
        font-size: 14px !important;
        font-weight: bold !important;
    }
    .candidates-container {
        max-width: 100%;
        overflow-y: auto;
    }
</style>
